import { Button, styled } from "@mui/material";

export const StyledOrderButton = styled(Button)`
  padding: 2px 0;
  min-width: 0;
`;
